import { useNavigate } from 'react-router-dom';

// Add this custom navbar component at the top of the file after imports
const FeedbackNavbar = () => {
  const navigate = useNavigate();
  
  return (
    <nav style={{ 
      backgroundColor: '#f8f9fa', 
      padding: '10px 20px', 
      borderBottom: '1px solid #dee2e6',
      display: 'flex',
      alignItems: 'center'
    }}>
      <button 
        onClick={() => navigate(-1)}
        style={{
          background: 'none',
          border: 'none',
          fontSize: '18px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}
      >
        ← Back
      </button>
    </nav>
  );
};

export default FeedbackNavbar;